<!-- Navbar + drawer (persistent; was mc-sub-navbar's named outlets, now direct children + page-chrome slots) -->
<mat-sidenav-container class="mc-app-shell-sidenav-container mc-navbar-container" hasBackdrop="true">
  <mat-sidenav #drawer class="mc-app-shell-sidenav mc-page-drawer" fixedInViewport="true" role="navigation" mode="over" [fixedTopGap]="(topGap$ | async)" (click)="onDrawerClicked($event)">
    <mc-app-drawer-nav *ngIf="(showAppDrawerNav | async)?.matches"></mc-app-drawer-nav>
    <!-- per-page drawer nav, projected from the routed page/feature wrapper (was the page-drawer-nav outlet) -->
    <ng-container *ngIf="(showAppDrawerNav | async)?.matches">
      <ng-container *ngTemplateOutlet="pageChrome.drawerNav()"></ng-container>
    </ng-container>
    <mc-app-drawer-gutter *ngIf="(showAppDrawerGutter | async)?.matches"></mc-app-drawer-gutter>
    <!-- per-page drawer content, projected from the routed page/feature wrapper (was the page-drawer-gutter outlet) -->
    <ng-container *ngIf="(showAppDrawerGutter | async)?.matches">
      <ng-container *ngTemplateOutlet="pageChrome.drawer()"></ng-container>
    </ng-container>
    <!-- always-available per-page drawer (was the page-drawer-gutter-always outlet) — keeps the burger enabled -->
    <ng-container *ngTemplateOutlet="pageChrome.drawerAlways()"></ng-container>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar class="mc-navbar" color="secondary">
      <div class="mc-navbar-heading">
        <button mat-button type="button" class="mc-navbar-drawer-toggle" [style.display]="pageChrome.drawerAlways() || (showAppDrawer | async)?.matches ? 'flex' : 'block'" aria-label="Toggle sidenav" [disabled]="!pageChrome.drawerAlways() && !(showAppDrawer | async)?.matches" (click)="drawer.toggle()">
          <mat-icon fontSet="project-titan" fontIcon="icon-burger" class="mc-navbar-title-icon mc-text-large" *ngIf="pageChrome.drawerAlways() || (showAppDrawer | async)?.matches"></mat-icon>
          <mat-icon fontSet="project-titan" fontIcon="icon-close" class="mc-navbar-title-icon mc-text-large"></mat-icon>
          <!-- per-page heading, projected from the routed page via PageChromeService -->
          <ng-container *ngTemplateOutlet="pageChrome.heading()"></ng-container>
        </button>
      </div>

      <!-- per-page navbar tab links + toolbar actions, projected from the routed page/feature wrapper -->
      <ng-container *ngTemplateOutlet="pageChrome.navbarTabLinks()"></ng-container>
      <ng-container *ngTemplateOutlet="pageChrome.navbarToolbar()"></ng-container>
      <span class="mc-fill-remaining-flex-space"></span>
      <!-- persistent app-level user launch-pad (message center + notifications + avatar menu) -->
      <mc-app-navbar-user-launch-pad *ngIf="(showAppNavbarLaunchPad | async)?.matches"></mc-app-navbar-user-launch-pad>
    </mat-toolbar>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Routed page body -->
<main class="mc-page mc-page-fill">
  <router-outlet></router-outlet>

  <aside class="mc-page-card mc-page-gutter" *ngIf="!pageChrome.gutterHidden() && (showPageGutter | async)?.matches">
    <mc-app-gutter></mc-app-gutter>
    <!-- per-page gutter content, projected from the routed page (was the page-gutter outlet) -->
    <ng-container *ngTemplateOutlet="pageChrome.gutter()"></ng-container>
  </aside>
</main>

<!-- Persistent app logo + left app-nav -->
<button mat-button class="mc-app-shell-logo" (click)="onLogoClicked()" *ngIf="(showAppNav | async)?.matches">
  <img alt="Flare Online Logo" class="mc-app-shell-logo-image" src="assets/images/app-logo.svg">
</button>
<mc-app-nav class="mc-app-shell-app-nav" *ngIf="(showAppNav | async)?.matches"></mc-app-nav>
